import React, { useEffect, KeyboardEvent } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, AutoComplete, Input, Row, Col, Typography } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import QueryString from 'query-string'
import ProfileAvatar from '../ProfileAvatar/ProfileAvatar'

import { useSearchContext } from '../../../context/search'
import { useExpertsContext } from '../../../context/experts'
import { useChannelContext } from '../../../context/channel'
import { RoutePath } from '../../routes'

import { TSearchResult } from '../../../context/types'

import './search.less'

const { Text } = Typography

type TSearchProps = {
	withoutButton?: boolean
}

function Search(props: TSearchProps) {
	const history = useHistory()

	const { search, actions } = useSearchContext()
	const { actions: expertsActions } = useExpertsContext()
	const { channel } = useChannelContext()

	useEffect(() => {
		const { q }: { q?: string } = QueryString.parse(history.location.search)

		if (q && q !== search.value) actions.setValue(q)
	}, [history.location])

	useEffect(() => {
		const delayDebounceFn = setTimeout(() => {
			actions.search(search.value)
		}, 500)

		return () => clearTimeout(delayDebounceFn)
	}, [search.value])

	function onSearch(inputValue: string) {
		actions.setValue(inputValue)
		if (!inputValue) expertsActions.getExperts({ channel: channel.selectedChannelId })
	}

	const onSelect = (idx: string) => {
		actions.select(search.results[+idx])
	}

	const handleSearch = () => {
		const searchFilter = search.value
			? { q: search.value, channel: channel.selectedChannelId }
			: { channel: channel.selectedChannelId }
		expertsActions.getExperts(searchFilter, 0, !history.location.pathname.includes(RoutePath.Experts))
		// history.push(RoutePath.Experts)
	}

	const onInputKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Enter') handleSearch()
	}

	return (
		<div className="header-search">
			<AutoComplete
				allowClear
				dropdownMatchSelectWidth={500}
				value={search.value}
				dropdownClassName="header-search-dropdown"
				options={search.results.map((result: TSearchResult, idx: number) => ({
					label: (
						<Row wrap={false} align="middle" className="header-search-row">
							<Col flex="70px">
								<ProfileAvatar
									className="experts-avatar"
									src={result.profile_pic_url}
									size={{ xs: 60, sm: 60, md: 65, lg: 65, xl: 70, xxl: 70 }}
								/>
							</Col>
							<Col flex="10px" />
							<Col flex="auto">
								<Text style={{ fontSize: 16, fontWeight: 500, display: 'block' }}>
									{result.first_name} {result.last_name}
								</Text>
								<Text style={{ fontSize: 14 }}>{result.title}</Text>
								<br />
								{result.body && (
									<Text type="secondary" ellipsis style={{ fontSize: 12, maxWidth: '100%' }}>
										{result.body}
									</Text>
								)}
							</Col>
						</Row>
					),
					value: idx.toString(), // Temperay fix created ticket #WISE-646
				}))}
				onSelect={onSelect}
				onSearch={onSearch}
				onClear={() => actions.setValue(null)}
				onInputKeyDown={onInputKeyDown}
				className="header-search-main"
			>
				<Input
					placeholder="Type your search here"
					prefix={<SearchOutlined className="header-search-full" style={{ color: '#1890ff' }} />}
					suffix={
						<SearchOutlined
							className="header-search-mobile"
							style={{ color: '#1890ff', fontSize: 24 }}
							onClick={handleSearch}
						/>
					}
				/>
			</AutoComplete>
			{!props.withoutButton && (
				<Button className="header-search-full" type="primary" shape="round" onClick={handleSearch}>
					Find Experts
				</Button>
			)}
		</div>
	)
}

export default Search
